import './App.css';
import { MdEmail, MdContactMail } from "react-icons/md";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import {
  FaHome,
  FaUser,
  FaCogs,
  FaFolderOpen,
  FaInfoCircle,
  FaBriefcase,
  FaProjectDiagram,
  FaTools,
  FaEye,
  FaCommentDots,
  FaMoon,
  FaSun
} from "react-icons/fa";
import { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  const [darkMode, setDarkMode] = useState(false);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className={darkMode ? "dark-theme" : ""}>

      {/* NAVBAR */}
      <nav className="navbar">
        <h1 className="logo">Eldrin Zarima</h1>

        <ul className="nav-links">
          <li><a href="#home"><FaHome /> Home</a></li>
          <li><a href="#about"><FaUser /> About</a></li>
          <li><a href="#services"><FaCogs /> Services</a></li>
          <li><a href="#projects"><FaFolderOpen /> Projects</a></li>
          <li><a href="#contact"><MdEmail /> Contact</a></li>
        </ul>
        
        <div className="nav-actions">

  {/* DOWNLOAD CV BUTTON */}
  <a
    href="/cv.pdf"
    download="Eldrin_Zarima_CV.pdf"
    className="cv-btn"
  >
    Download CV
  </a>

  {/* THEME TOGGLE */}
  <button id="theme-toggle" onClick={toggleTheme}>
    {darkMode ? <FaSun /> : <FaMoon />}
  </button>
</div>
      </nav>

      {/* HERO */}
      <section id="home" className="hero" data-aos="fade-in">
        <h2 data-aos="fade-down">Hello, I'm</h2>
        <h1 data-aos="zoom-in">Eldrin Zarima</h1>

        <h3 className="hero-role">
          Full-Stack Developer | React • Node • UI/UX
        </h3>

        <p>
          I build modern, scalable and responsive web applications with clean UI and strong backend systems.
        </p>

        <div className="hero-buttons">
          <a href="#projects" className="hero-btn primary">
            <FaEye className="btn-icon" />
            View Projects
          </a>

          <a href="#contact" className="hero-btn secondary">
            <FaCommentDots className="btn-icon" />
            Hire Me
          </a>
        </div>
      </section>

      {/* ABOUT */}
      <section id="about" className="section">
        <h2><FaInfoCircle /> About Me</h2>

        <h3>
          I am a Software Engineering student passionate about building real-world applications and solving problems through technology.
        </h3>

        <div className="about-container">
          <div className="about-card">
            <h3>Frontend Development</h3>
            <p>React JS, HTML, CSS, JavaScript.</p>
          </div>

          <div className="about-card">
            <h3>Backend Development</h3>
            <p>Node JS, Express, APIs, Databases.</p>
          </div>

          <div className="about-card">
            <h3>Problem Solving</h3>
            <p>Building efficient and scalable solutions.</p>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" className="section dark">
        <h2><FaBriefcase /> Services</h2>

        <div className="cards">
          <div className="card"><h3>Web Development</h3><p>Modern React websites.</p></div>
          <div className="card"><h3>Backend Development</h3><p>Node JS APIs.</p></div>
          <div className="card"><h3>Database Design</h3><p>MySQL & MongoDB.</p></div>
          <div className="card"><h3>UI/UX Design</h3><p>Clean user interfaces.</p></div>
        </div>
      </section>

      {/* SKILLS */}
      <section id="skills" className="section">
        <h2><FaTools /> Skills</h2>

        <div className="cards">
          <div className="card">React JS</div>
          <div className="card">Node JS</div>
          <div className="card">JavaScript</div>
          <div className="card">MySQL</div>
          <div className="card">MongoDB</div>
          <div className="card">Git & GitHub</div>
        </div>
      </section>

      {/* PROJECTS */}
      <section id="projects" className="section dark">
        <h2><FaProjectDiagram /> Projects</h2>

        <div className="cards">

          {/* PROJECT 1 */}
          <div className="card">
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c"
              alt="Accommodation"
              style={{ width: "100%", borderRadius: "10px", marginBottom: "10px" }}
            />

            <h3>UZ Off Campus Accommodation</h3>

            <p>Students booking boarding houses easily online.</p>

            <a href="https://github.com/eldrinzarima/UZ-Off-Campus-Accommodation"
              target="_blank"
              rel="noreferrer">
              View Project
            </a>
          </div>

          {/* PROJECT 2 */}
          <div className="card">
            <img
              src="https://images.unsplash.com/photo-1523240795612-9a054b0db644"
              alt="Student Management System"
              style={{ width: "100%", borderRadius: "10px", marginBottom: "10px" }}
            />

            <h3>Student Management System</h3>

            <p>
              A platform that helps students manage assignments, notes and schedules in one place for better organization and productivity.
            </p>

            <a href="https://github.com/eldrinzarima/Student-Management-System"
              target="_blank"
              rel="noreferrer">
              View Project
            </a>
          </div>

        </div>
      </section>


      {/* CONTACT */}
      <section id="contact" className="section">
        <h2><MdContactMail /> Contact</h2>

        <div className="contact-container">

          <div className="contact-card">
            <MdEmail />
            <h3>Email</h3>
            <a href="mailto:zarimaeldrin@gmail.com">zarimaeldrin@gmail.com</a>
          </div>

          <div className="contact-card">
            <FaPhoneAlt />
            <h3>Phone</h3>
            <a href="tel:+263781580669">+263 78 158 0669</a>
          </div>

          <div className="contact-card">
            <FaWhatsapp />
            <h3>WhatsApp</h3>
            <a href="https://api.whatsapp.com/send?phone=263712373162"
              target="_blank"
              rel="noreferrer">
              Chat on WhatsApp
            </a>
          </div>

        </div>
      </section>
      {/* HIRE ME SECTION */}
<section id="hire" className="section dark">
  <h2>Available for Opportunities</h2>

  <p>
    I am currently open to internships, freelance projects, and entry-level
    full-stack developer roles. I am passionate about building real-world
    applications and gaining industry experience.
  </p>

  <div className="hire-buttons">

    <a href="#contact" className="hero-btn primary">
      <FaCommentDots className="btn-icon" />
      Contact Me
    </a>

    <a
      href="mailto:zarimaeldrin@gmail.com"
      className="hero-btn secondary"
    >
      <MdEmail className="btn-icon" />
      Send Email
    </a>

  </div>
</section>

     {/* FOOTER */}
<footer className="footer">

  <div className="footer-main">

    {/* BRAND CARD */}
    <div className="footer-card brand-card">
      <h2>Eldrin Zarima</h2>
      <p>
        Full-stack developer building modern, scalable and responsive
        digital solutions with React, Node.js and clean UI systems.
      </p>
    </div>

    {/* NAVIGATION CARD */}
    <div className="footer-card">
      <h3>Navigation</h3>

      <a href="#home" className="footer-link">Home</a>
      <a href="#about" className="footer-link">About</a>
      <a href="#skills" className="footer-link">Skills</a>
      <a href="#projects" className="footer-link">Projects</a>
      <a href="#hire" className="footer-link">Hire Me</a>
      <a href="#contact" className="footer-link">Contact</a>
    </div>

    {/* SERVICES CARD */}
    <div className="footer-card">
      <h3>Services</h3>

      <p>Web Development</p>
      <p>Backend Systems</p>
      <p>Database Design</p>
      <p>UI / UX Design</p>
    </div>

    {/* CONTACT CARD */}
    <div className="footer-card">
      <h3>Contact</h3>

      <p>📍 Harare, Zimbabwe</p>

      <a href="mailto:zarimaeldrin@gmail.com" className="footer-link">
        📧 Email Me
      </a>

      <a href="tel:+263781580669" className="footer-link">
        📞 Call Me
      </a>

      <a
        href="https://api.whatsapp.com/send?phone=263712373162"
        target="_blank"
        rel="noreferrer"
        className="footer-link"
      >
        💬 WhatsApp
      </a>
    </div>

    {/* SOCIAL / EXTRA CARD */}
    <div className="footer-card">
      <h3>More</h3>

      <p>Open for internships</p>
      <p>Freelance available</p>
      <p>Full-stack developer</p>
      <p>UI focused builder</p>
    </div>

  </div>

  {/* BOTTOM BAR */}
  <div className="footer-bottom">
    <p>© 2026 Eldrin Zarima. All rights reserved.</p>
  </div>

</footer>

    </div>
  );
}

export default App;